<template>
<div>
  <vs-button
    color="success"
    type="border"
    icon-pack="feather"
    icon="icon-file-text"
    class="w-full"
    @click="this.export"
    :disabled="disabled"
  >
    {{ $t('export') }}
  </vs-button>

  <vs-popup
      :title="$t('confirm')|capitalize"
      :active.sync="popupActive"
    >
      <vs-row>
        <div>
          <p>
          {{formatNumber(limit_export)}} {{$t('registers_will_be_exported')}}. {{$t('are_you_sure')}}
          </p>
        </div>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="center" class="my-2">
        <vs-col vs-w="4">
          <vs-button @click="popupActive = false"
          >{{$t('go_back')|capitalize}}</vs-button>
        </vs-col>
        <vs-col vs-w="4">
          <vs-button
            @click="confirmExport"
            color="success"
          >
            {{$t('export')|capitalize}}
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

</div>
</template>

<script>
import {BASE_URL} from '@/urls.js'

export default {
  props: {
    url:{
      type:String
    },
    type:{
      type:String
    },
    data:{
      type:Object
    },
    disabled:{
      type:Boolean,
      default:false
    },
    limit_export:{
      type:Number,
      default:1
    }
  },
  data() {
    return {
      popupActive:false
    }
  },
  methods: {
    export(){
      if(this.limit_export>10000){
        //open Alert
        this.popupActive=true
      }else{
        this.routeGETexport()
      }
    },
    confirmExport(){
      this.popupActive=false
      this.routeGETexport()
    },
    routeGETexport(){
      let request = this.buildRequest();
      let new_url = BASE_URL + '/internal_api/' + this.url + request
      window.open(new_url)
    },
    buildRequest(){
      let request = `?id=${this.$store.state.AppActiveUser.id}`
      Object.keys(this.data).forEach(key => {
        if (this.data[key] != undefined) {
          if(Array.isArray(this.data[key])){
            this.data[key].forEach(element => {
              request += `&${key}[]=${element}`
            });
          }else{
            request += `&${key}=${this.data[key]}`
          }
        }
      });
      return request;
    }
  }
}
</script>

<style>
</style>